<template>
  <filters-form
    :initial="initial"
    :scrollable="scrollable"

    :items="items"
    :loading="loading"
    :filters="filters"

    :schema="schema"
    :payload="payload"

    :actions="actions"
    :per-page="perPage"

    @reload="reloadKind"
  />
</template>

<script>
  import { mapState } from 'vuex';

  import namelize from '@sdk/helpers/formatters/namelize';

  import form from '@cordel/helpers/form/mixin';
  import optionsHelper from '@cordel/helpers/form/select/options';

  import FiltersForm from '@sdk/components/Filters/Form.vue';

  // eslint-disable-next-line import/no-extraneous-dependencies
  import preload from '@/helpers/mixins/preload';

  // eslint-disable-next-line import/no-extraneous-dependencies
  import { INITIAL_PROPOSAL_FILTERS as INITIAL } from '@/store/modules/proposals';

  import payloadGenerator from './payload';
  import schemaGenerator from './schema';

  import {
    SELLER_ID,
    STORE_ID,
    BANK_CODE,
    // SORT
  } from './fields';

  export default {
    name: 'ProposalsApprovedFilters',
    components: {
      FiltersForm,
    },
    mixins: [
      form,
      preload,
    ],
    props: {
      scrollable: {
        type: Boolean,
        default: true,
      },
      perPage: {
        type: Number,
        default: null,
      },
    },
    data() {
      return {
        schema: schemaGenerator(),
        payload: payloadGenerator(),

        initial: INITIAL,

        actions: {
          filter: 'proposals/filter',
          clear: 'proposals/clear',
          list: 'proposals/approved',
        },
      };
    },
    computed: {
      ...mapState([
        'banksWeb',
        'proposals',
        'stores',
        'sellers',
      ]),

      items() {
        return this.proposals.list.items;
      },
      loading() {
        return this.proposals.list.loading;
      },
      filters() {
        return this.proposals.list.filters;
      },
    },
    mounted() {
      this.getSellers();
      this.getStores();
      this.getBanks();
    },
    methods: {
      getBanks() {
        this.updateLoading(BANK_CODE, true);
        this.preloadBanksWeb(true, { main: true }).then(this.gotBanks);
      },
      gotBanks() {
        this.updateLoading(BANK_CODE, false);
        this.updateOptions(BANK_CODE, optionsHelper(this.banksWeb.list.items, {
          value: 'code',
        }));
      },

      reloadStores(filters) {
        this.getStores(false, filters);
      },
      getStores(cached, payload) {
        this.updateLoading(STORE_ID, true);
        this.preloadStores(cached, payload).then(this.gotStores);
      },
      gotStores() {
        this.updateLoading(STORE_ID, false);
        this.updateOptions(STORE_ID, optionsHelper(this.stores.list.items));
      },

      reloadSellers(filters) {
        this.getSellers(false, filters);
      },
      getSellers(cached, payload) {
        this.updateLoading(SELLER_ID, true);
        this.preloadSellers(cached, payload).then(this.gotSellers);
      },
      gotSellers() {
        this.updateLoading(SELLER_ID, false);
        this.updateOptions(SELLER_ID, optionsHelper(this.sellers.list.items, {
          prettify: namelize,
        }));
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .proposals-approved-filters {
  }
</style>
